// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.

import { QuickTableRactive } from "../elements/QuickTable/QuickTableRactive.js";
import { PanelNames } from "../UtilsClasses/FactoryConstants.js";
import { AdditionalRowDataKeys, ApplicationPanelNew } from "./ApplicationPanelNew.js";
import { DynProperty } from "../../Commons/DynProperty.js";
import { GeneralSettings } from "../../Utils/GeneralSettings/GeneralSettings.js";
import { DataCache } from "../../Commons/DataCache.js";
import { Quantity } from "../../Utils/Trading/Quantity.js";
import { UpdatePackageInfo } from "./Factory.js";


// TODO. Extend EmbeddedApplicationPanelNew (different template).
export let TerceraPortfolioTable = ApplicationPanelNew.extend({
    data: function ()
    {
        return {
            withBorderRadius: false,
            withOutBorder: true,
            showHeader: false,
            showFooter: false,
            movable: false,
            resizable: false,
            dockablePanel: false,
            width: 296,
            height: 220,
            zIndex: 0
        };
    }
});

TerceraPortfolioTable.prototype.getType = function ()
{
    return PanelNames.PortfolioTable;
};

TerceraPortfolioTable.prototype.oninit = function ()
{
    ApplicationPanelNew.prototype.oninit.apply(this);
};

TerceraPortfolioTable.prototype.oncomplete = function ()
{
    ApplicationPanelNew.prototype.oncomplete.apply(this);
    this.quickTableRactive.on(
        QuickTableRactive.Events.DoubleClick,
        this.onDoubleClick.bind(this));

    var qt = this.quickTableRactive.quickTable;
    qt.allowGroupBy = false;
    qt.AddToEnd = false;
    qt.AfterButtonItem.Subscribe(this.onAfterButtonItem, this);
    qt.AfterEditItem.Subscribe(this.onAfterEditItem, this);
};

TerceraPortfolioTable.prototype.dispose = function ()
{
    ApplicationPanelNew.prototype.dispose.apply(this);
};

TerceraPortfolioTable.prototype.setBounds = function (x, y, w, h)
{
    ApplicationPanelNew.prototype.setBounds.call(this, x, y, w, h);
    this.layoutTable();
};

TerceraPortfolioTable.prototype.layoutTable = function ()
{
    if (!this.quickTableRactive)
        return;

    this.quickTableRactive.setBounds(
        0,
        0,
        this.get('width'),
        this.get('height'));
};

TerceraPortfolioTable.prototype.onAfterButtonItem = function (params)
{
    var row = params.row;
    if (!row) return;

    this.fire(TerceraPortfolioTable.Events.RemoveRow, row.id);
};

TerceraPortfolioTable.prototype.onAfterEditItem = function (params)
{
    var row = params.row;
    if (!row) return;

    var qt = this.quickTableRactive.quickTable;
    var colIdx = params.columnIndex;
    switch (colIdx)
    {
        // Quantity.
        case 1:
            this.fire(TerceraPortfolioTable.Events.QuantityRow, row.id, params.newValue);
            break;
            // Analyze.
        case 4:
            this.fire(TerceraPortfolioTable.Events.AnalyzeRow, row.id);
            break;
    }
};

TerceraPortfolioTable.prototype.Update = function (pckg)
{
    ApplicationPanelNew.prototype.Update.call(this, pckg);

    var rowIdsFromWorkspaceLoadingSet = {};
    var additionalRowsData = pckg.additionalRowsData;
    var len = additionalRowsData.length;
    for (var i = 0; i < len; i++)
    {
        var obj = additionalRowsData[i];
        if (obj.additionalData[AdditionalRowDataKeys.FROM_WS_LOADING_KEY])
            rowIdsFromWorkspaceLoadingSet[obj.id] = true;
    }

    // Search of the newly added row to set user defined data (quantity).
    var addedRemovedRows = pckg.addedRemovedRows;
    var len = addedRemovedRows.length;
    for (var i = 0; i < len; i++)
    {
        var addedRemovedRow = pckg.addedRemovedRows[0];
        var rowId = addedRemovedRow[0];

        if (rowIdsFromWorkspaceLoadingSet[rowId])
            continue;

        if (addedRemovedRow[1] === UpdatePackageInfo.ADD_ROW)
        {
            this.waitRowIdData = rowId;
            break;
        }
    }

    var waitRowIdData = this.waitRowIdData;
    if (!waitRowIdData) return;

    var qt = this.quickTableRactive.quickTable;
    var qtRows = qt.rows;
    var updatedRows = pckg.updatedRows;
    len = updatedRows.length;
    for (var i = 0; i < len; i++)
    {
        var updatedRow = updatedRows[i];
        var rowId = updatedRow.id;
        if (rowId !== waitRowIdData)
            continue;

        var row = qtRows[rowId];
        var qtyCell = row.cells[1];

        // HACK. http://tp.pfsoft.net/entity/53106
        var qtyNumericSettings = Quantity.getQuantityNumericSettings(
            DataCache.getInstrumentByName(row.cells[0].value),
            GeneralSettings.View.DisplayQuantityInLots);
        if (qtyNumericSettings)
            qtyCell.value = qtyNumericSettings.value;

        qt.BeginEdit(qtyCell.QuickTableEditingInfo, qtyCell, row, 1, 1);
        delete this.waitRowIdData;

        return;
    }
};

TerceraPortfolioTable.prototype.onDoubleClick = function ()
{
    this.fire(QuickTableRactive.Events.DoubleClick);
};

//#region ICaller

TerceraPortfolioTable.prototype.callBack = function (newProperties)
{
    ApplicationPanelNew.prototype.callBack.call(this, newProperties);

    var dp = DynProperty.getPropertyByName(newProperties, 'Instruments');
    if (!dp) return;

    var rawJsonString = dp.value;
    if (!rawJsonString) return;

    var insArr = JSON.parse(rawJsonString);
    if (!insArr) return;

    this.fire(TerceraPortfolioTable.Events.LoadRows, insArr);
};

TerceraPortfolioTable.prototype.Properties = function ()
{
    var properties = ApplicationPanelNew.prototype.Properties.call(this);

    var rows = this.quickTableRactive.quickTable.rowsArray;
    var len = rows.length;
    var inLots = GeneralSettings.View.DisplayQuantityInLots;
    var insArr = [];
    for (var i = 0; i < len; i++)
    {
        var row = rows[i];
        var cells = row.cells;
        insArr.push({
            symbol: cells[0].value,
            inLots: inLots,
            quantity: cells[1].value,
            analyze: cells[4].value
        });
    }

    properties.push(new DynProperty('Instruments', JSON.stringify(insArr), DynProperty.STRING, DynProperty.HIDDEN_GROUP));
    return properties;
};

//#endregion

TerceraPortfolioTable.Events = {
    RemoveRow: 'RemoveRow',
    AnalyzeRow: 'AnalyzeRow',
    QuantityRow: 'QuantityRow',
    LoadRows: 'LoadRows'
};

TerceraPortfolioTable.prototype.repopulate = function ()
{
    var props = this.Properties();
    this.quickTableRactive.quickTable.ClearAll();
    this.callBack(props);
};